import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./sections/HeroSection.jsx";
import HighlightsSection from "./sections/HighlightsSection.jsx";
import HowItWorksSection from "./sections/HowItWorksSection.jsx";
import TestimonialsSection from "./sections/TestimonialsSection.jsx";
import PackagesSection from "./sections/PackagesSection.jsx";
import AboutUsSection from "./sections/AboutUsSection.jsx";
import CallToActionSection from "./sections/CallToActionSection.jsx";
import { scrollToSection } from "../../../utils/scrollToSection.js";

export default function HomePage() {
  const location = useLocation();

  // Ao chegar de outra rota pedindo uma seção (menu -> âncora), rola até ela.
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    // Aguarda o layout montar (imagens acima podem deslocar a posição).
    const timer = setTimeout(() => scrollToSection(target), 150);
    // Limpa o state para não repetir o scroll em re-render/refresh.
    window.history.replaceState({}, "");
    return () => clearTimeout(timer);
  }, [location.state]);

  return (
    <div className="min-h-screen bg-[var(--color-warm-50)]">
      <HeroSection />
      <HighlightsSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <PackagesSection />
      <AboutUsSection />
      <CallToActionSection />
    </div>
  );
}